import MarketIndexSummaryCards from './MarketIndexSummaryCards';
import MarketLineChartView from './MarketLineChartView';
import useMarketData from './hooks/useMarketData';

function WorldIndicesView() {
  const { dates, series, loading, error } = useMarketData('world');

  return (
    <>
      <div className="row market-summary-row mb-4">
        <MarketIndexSummaryCards series={series} loading={loading} />
      </div>
      <div className="row mb-4">
        <MarketLineChartView
          chartId="world-indices"
          title="World Indices"
          series={series}
          dates={dates}
          loading={loading}
          error={error}
        />
      </div>
    </>
  );
}

export default WorldIndicesView;
